import { color } from '@core-ds/primitives';
import { ButtonType, ButtonColor } from './button';

type StylesByButtonType = {
   [key in ButtonType]: ByButtonColor;
}

type ByButtonColor = {
   [key in ButtonColor]?: ButtonInteractions
}

interface ButtonInteractions {
   default: ButtonColorStyles;
   hover: ButtonColorStyles;
   focus: ButtonColorStyles
}

interface ButtonColorStyles {
   fontColor: string;
   backgroundColor: string;
   border: string;
}

const darkBlue: ButtonInteractions = {
   default: {
      fontColor: color.white,
      backgroundColor: color.blue,
      border: 'none'
   },
   hover: {
      fontColor: color.white,
      backgroundColor: color.blueDark1,
      border: 'none'
   },
   focus: {
      fontColor: color.white,
      backgroundColor: color.blueDark2,
      border: 'none'
   }
};

const lightBlack: ButtonInteractions = {
   default: {
      fontColor: color.gray8,
      backgroundColor: color.gray1,
      border: 'none'
   },
   hover: {
      fontColor: color.gray8,
      backgroundColor: color.gray2,
      border: 'none'
   },
   focus: {
      fontColor: color.gray8,
      backgroundColor: color.gray3,
      border: 'none'
   }
};

export const stylesByButtonType: StylesByButtonType = {
   default: {
      default: {
         default: {
            fontColor: color.gray8,
            backgroundColor: color.white,
            border: `1px solid ${color.gray3}`
         },
         hover: {
            fontColor: color.gray8,
            backgroundColor: color.white,
            border: `1px solid ${color.gray5}`
         },
         focus: {
            fontColor: color.gray8,
            backgroundColor: color.white,
            border: `1px solid ${color.gray7}`
         }
      }
   },

   primary: {
      default: darkBlue
   },

   secondary: {
      default: lightBlack
   },

   dark: {
      default: darkBlue,
      green: {
         default: {
            fontColor: color.white,
            backgroundColor: color.green,
            border: 'none'
         },
         hover: {
            fontColor: color.white,
            backgroundColor: color.greenDark1,
            border: 'none'
         },
         focus: {
            fontColor: color.white,
            backgroundColor: color.greenDark2,
            border: 'none'
         }
      },
      red: {
         default: {
            fontColor: color.white,
            backgroundColor: color.red,
            border: 'none'
         },
         hover: {
            fontColor: color.white,
            backgroundColor: color.redDark1,
            border: 'none'
         },
         focus: {
            fontColor: color.white,
            backgroundColor: color.redDark2,
            border: 'none'
         }
      },
      yellow: {
         default: {
            fontColor: color.gray8,
            backgroundColor: color.yellow,
            border: 'none'
         },
         hover: {
            fontColor: color.gray8,
            backgroundColor: color.yellowDark1,
            border: 'none'
         },
         focus: {
            fontColor: color.gray8,
            backgroundColor: color.yellowDark2,
            border: 'none'
         }
      },
      blue: darkBlue,
      black: {
         default: {
            fontColor: color.white,
            backgroundColor: color.black,
            border: 'none'
         },
         hover: {
            fontColor: color.white,
            backgroundColor: color.gray8,
            border: 'none'
         },
         focus: {
            fontColor: color.white,
            backgroundColor: color.gray7,
            border: 'none'
         }
      }
   },

   light: {
      default: lightBlack,
      green: {
         default: {
            fontColor: color.greenDark1,
            backgroundColor: color.greenLight4,
            border: 'none'
         },
         hover: {
            fontColor: color.greenDark2,
            backgroundColor: color.greenLight3,
            border: 'none'
         },
         focus: {
            fontColor: color.greenDark3,
            backgroundColor: color.greenLight2,
            border: 'none'
         }
      },
      red: {
         default: {
            fontColor: color.redDark1,
            backgroundColor: color.redLight4,
            border: 'none'
         },
         hover: {
            fontColor: color.redDark2,
            backgroundColor: color.redLight3,
            border: 'none'
         },
         focus: {
            fontColor: color.redDark3,
            backgroundColor: color.redLight2,
            border: 'none'
         }
      },
      yellow: {
         default: {
            fontColor: color.yellowDark1,
            backgroundColor: color.yellowLight4,
            border: 'none'
         },
         hover: {
            fontColor: color.yellowDark2,
            backgroundColor: color.yellowLight3,
            border: 'none'
         },
         focus: {
            fontColor: color.yellowDark3,
            backgroundColor: color.yellowLight2,
            border: 'none'
         }
      },
      blue: {
         default: {
            fontColor: color.blueDark1,
            backgroundColor: color.blueLight4,
            border: 'none'
         },
         hover: {
            fontColor: color.blueDark2,
            backgroundColor: color.blueLight3,
            border: 'none'
         },
         focus: {
            fontColor: color.blueDark3,
            backgroundColor: color.blueLight2,
            border: 'none'
         }
      },
      black: lightBlack
   },

   'dark-legacy': {
      default: {
         default: {
            fontColor: color.gray1,
            backgroundColor: '#343739',
            border: 'none'
         },
         hover: {
            fontColor: color.gray1,
            backgroundColor: color.gray7,
            border: 'none'
         },
         focus: {
            fontColor: color.gray1,
            backgroundColor: color.gray7,
            border: 'none'
         }
      }
   },
};
